module.exports = __webpack_public_path__ + "static/media/intro.00f54875.mp3";